import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { memberEditService } from '../services/memberEdit.service';
import type { MemberEditData, RoleOption, TeamOption } from '../types/memberEdit.types';

export function useMemberEdit(id: string | null) {
  const [member, setMember] = useState<MemberEditData | null>(null);
  const [roles, setRoles] = useState<RoleOption[]>([]);
  const [teams, setTeams] = useState<TeamOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!id) return;
    async function loadData() {
      try {
        setIsLoading(true);
        const [memberData, rolesData, teamsData] = await Promise.all([
          memberEditService.getMemberById(id),
          memberEditService.getRoles(),
          memberEditService.getTeams()
        ]);
        setMember(memberData);
        setRoles(rolesData);
        setTeams(teamsData);
      } catch (error: any) {
        toast.error('Không thể tải thông tin thành viên');
      } finally {
        setIsLoading(false);
      }
    }
    loadData();
  }, [id]);

  const updateMember = async (data: Partial<MemberEditData>) => {
    if (!id) return false;
    try {
      setIsSubmitting(true);
      await memberEditService.updateMember(id, data);
      toast.success('Thông tin thành viên đã được cập nhật');
      return true;
    } catch (error: any) {
      toast.error(error.message || 'Lỗi khi cập nhật thành viên');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { member, roles, teams, isLoading, isSubmitting, updateMember };
}
